(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!reduceMotion) {
    const revealTargets = document.querySelectorAll('[data-reveal]');

    revealTargets.forEach((el) => {
      const idx = el.getAttribute('data-reveal-index');
      if (idx) el.style.setProperty('--reveal-index', idx);
    });

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -48px 0px' }
    );

    revealTargets.forEach((el) => io.observe(el));
  }

})();
